var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7.5a3 3 0 1 0-2.861-2.096l-7.073 4.42a3 3 0 1 0 0 4.351l7.073 4.421a3 3 0 1 0 .796-1.272l-7.074-4.42a2.999 2.999 0 0 0 0-1.808l7.073-4.42A2.99 2.99 0 0 0 18 7.5ZM18 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM6 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm13.5 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
  })));
};
export default SvgShare;